/**
 * Centralized constants for the application
 */

/**
 * Z-Index layers for consistent stacking order
 * Higher values appear on top
 */
export const Z_INDEX = {
  // Base layers
  BASE: 0,
  DROPDOWN: 1000,
  STICKY: 1020,
  FIXED: 1030,
  
  // Overlay layers
  OVERLAY: 1040,
  BACKDROP: 1050,
  
  // Modal/Drawer layers
  MODAL: 1060,
  DRAWER: 1070,
  TOAST: 1080,
  
  // Maximum layer (should rarely be used)
  MAXIMUM: 9999,
} as const;

/**
 * Drawer sizing constants
 */
export const DRAWER_SIZING = {
  MOBILE_WIDTH: '100vw',
  DESKTOP_MIN_WIDTH: 320,
  DESKTOP_MAX_WIDTH: 600,
  DESKTOP_MARGIN: 16, // 1rem = 16px
  MOBILE_SAFE_AREA_TOP: 'env(safe-area-inset-top, 0px)',
  MOBILE_SAFE_AREA_BOTTOM: 'env(safe-area-inset-bottom, 0px)',
  MOBILE_SAFE_AREA_LEFT: 'env(safe-area-inset-left, 0px)',
  MOBILE_SAFE_AREA_RIGHT: 'env(safe-area-inset-right, 0px)',
} as const;

/**
 * Chat Widget sizing constants
 */
export const CHAT_WIDGET_SIZING = {
  BUBBLE_SIZE: 60, // Minimized bubble size (60x60px)
  DESKTOP_WIDTH: 380, // Maximized width on desktop
  DESKTOP_HEIGHT: 600, // Maximized height on desktop
  DESKTOP_MIN_HEIGHT: 500,
  BOTTOM_MARGIN: 20, // Distance from bottom
  RIGHT_MARGIN: 20, // Distance from right
  MOBILE_BOTTOM_MARGIN: 80, // Account for mobile nav bar
} as const;

